import cn from 'classnames'
import * as React from 'react'

import styles from './card.module.scss'

interface ICardProps {
  children: React.ReactNode
  className?: string
  bordered?: boolean
  shadowed?: boolean
  style?: React.CSSProperties
}

const Card = ({ children, className, bordered, shadowed = true, style }: ICardProps) => (
  <div
    className={cn(styles.root, bordered && styles.withBorder, shadowed && styles.withShadow, className)}
    style={style}
  >
    {children}
  </div>
)

interface ICardHeaderProps {
  children?: React.ReactNode
  variant?: 'brand' | 'free'
  className?: string
}
const CardHeader = ({ children, className, variant = 'brand' }: ICardHeaderProps) => (
  <header className={[styles.header, styles[variant], className].join(' ')}>{children}</header>
)

interface ICardTitleProps {
  children: React.ReactNode
  className?: string
}
const CardTitle = ({ children, className }: ICardTitleProps) => (
  <div className={[styles.title, className].join(' ')}>{children}</div>
)

interface ICardBodyProps {
  children?: React.ReactNode
  className?: string
}
const CardBody = ({ children, className }: ICardBodyProps) => (
  <div className={[styles.body, className].join(' ')}>{children}</div>
)

export { Card, CardHeader, CardTitle, CardBody }
